export const actionTypes = {
  SET_ACTIVITY: 'activityBooking/SET_ACTIVITY',
  SET_DATE: 'activityBooking/SET_DATE',
  SET_DURATION: 'activityBooking/SET_DURATION',
  SET_RESOURCE: 'activityBooking/SET_RESOURCE',
  SET_PLAYERS: 'activityBooking/SET_PLAYERS',
  ADD_PLAYER: 'activityBooking/ADD_PLAYER',
  ASSIGN_PLAYER: 'activityBooking/ASSIGN_PLAYER',
  REPLACE_PLAYER_AT: 'activityBooking/REPLACE_PLAYER_AT',
  REMOVE_LAST_PLAYER: 'activityBooking/REMOVE_LAST_PLAYER',
  INIT_STATE: 'activityBooking/INIT_STATE',
  SET_ACTIVE_OPTION: 'activityBooking/SET_ACTIVE_OPTION',
  SET_SHOW_AVAILABILITY: 'activityBooking/SET_SHOW_AVAILABILITY',
  SET_TYPES: 'activityBooking/SET_TYPES',
  SET_TYPES_FILTERS: 'activityBooking/SET_TYPES_FILTERS',
  SET_ERROR: 'activityBooking/SET_ERROR',
};

export default {
  gql: {
    GET_ACTIVITIES: `
      query GetActivities {
        activities {
          items {
            id
            name
            okType
            abandon
            type {
              typeId
              name
              typeColor
            }
            startTime
            endTime
            interval
            dayMember
            dayGuest
            okCancel
            cancelTime
            maxPlayers
            joinIncompleteGroup
            allowGuestRegistration
            invoiceType
            hourPrice {
              hourPriceId
              time
              typeId
              pgbCodeProd
            }
            resources {
              resourceId
              typeId
              name
            }
          }
          totalCount
        }
      }
    `,
    GET_ROW_SLOTS: `
      query GetRowSlots(
        $date: String!
        $activity: Int!
        $type: Int
        $time: Int!
        $players: [PlayerInput!]!
      ) {
        activityRowSlots(
          date: $date
          activity: $activity
          type: $type
          time: $time
          players: $players
        ) {
          items {
            hour
            activitySlots {
              typeId
              resourceIds
              pricing {
                price
              }
            }
          }
          totalCount
        }
      }
    `,
    GET_ACTIVITY_HISTORY: `
      query GetActivityHistory(
        $golfId: String
        $dateMax: String
      ) {
        getActivityHistory(
          golfId: $golfId
          dateMax: $dateMax
        ) {
          id
          date
          time
          golf {
            id
            name
          }
          bookingId
          status
          nbPlayers
          total {
            currency
            price
            discount
            initPrice
          }
          isLocked
          activity {
            id
            typeId
            resourceId
            pgbCodeProd
            name
          }
          nbAccessories
          players {
            tid
            email
            gender
            handicap
            lastname
            firstname
            licenseNo
            bookId
            bookingId
            payments {
              id
              type
              amount
            }
            price
            discount
            initPrice
          }
        }
      }
    `,
    GET_ACTIVITY: `
      query GetActivity(
        $id: String!
      ) {
        getActivity(
          id: $id
        ) {
          id
          date
          time
          golf {
            id
            name
          }
          time9in
          owner {
            name
            email
            phone
            covidCertificate
          }
          total {
            currency
            price
            discount
            initPrice
          }
          paymentMethod
          activity {
            id
            typeId
            resourceId
            pgbCodeProd
            name
          }
          status {
            date
            status
            comment
          }
          players {
            tid
            email
            gender
            handicap
            lastname
            firstname
            licenseNo
            bookId
            bookingId
            payments {
              id
              type
              amount
            }
            price
            discount
            initPrice
          }
          payments {
            amount
            card
            type
            brand
            callNo
            country
            creditCardId
            transactionNo
          }
        }
      }
    `,
    ACTIVITY_BOOK: `
      mutation ActivityBook(
        $nb: Int!
        $date: String!
        $time: String!
        $time9in: String
        $duration: Int!
        $lockCode: String
        $accountId: String
        $golf: BookGolfInput!
        $owner: BookOwnerInput!
        $total: BookTotalInput!
        $activity: BookActivityInput!
        $comment: String
        $players: [ActivityPlayerInput]!
        $isPrivatized: Int
        $forceAnonymous: Int
      ) {
        activityBook(
          nb: $nb
          date: $date
          time: $time
          time9in: $time9in
          duration: $duration
          lockCode: $lockCode
          accountId: $accountId
          golf: $golf
          owner: $owner
          total: $total
          activity: $activity
          comment: $comment
          players: $players
          isPrivatized: $isPrivatized
          forceAnonymous: $forceAnonymous
        ) {
          id
          date
          time
          golf {
            id
            name
          }
          time9in
          owner {
            name
            email
            phone
            covidCertificate
          }
          total {
            currency
            price
            discount
            initPrice
          }
          paymentMethod
          activity {
            id
            typeId
            resourceId
            pgbCodeProd
            name
          }
          status {
            date
            status
            comment
          }
          players {
            tid
            email
            gender
            handicap
            lastname
            firstname
            licenseNo
            bookingId
            payments {
              id
              type
              amount
            }
            price
            discount
            initPrice
          }
          payments {
            amount
            card
            type
            brand
            callNo
            country
            creditCardId
            transactionNo
          }
        }
      }
    `,
    ACTIVITY_CANCEL: `
      mutation ActivityCancel(
      $id: String!
      $failed: Boolean
    ) {
        activityCancel(
          id: $id
          failed: $failed
        ) {
            status
          }
      }
    `,
    ACTIVITY_EDIT: `
      mutation ActivityEdit(
      $id: String
      $date: String!
      $time: String!
      $accountId: String!
      $golf: BookGolfInput!
      $activity: BookActivityInput!
      $owner: ActivityPlayer!
      $players: [ActivityPlayer]!
    ) {
        activityEdit(
          id: $id
          date: $date
          time: $time
          accountId: $accountId
          golf: $golf
          activity: $activity
          owner: $owner
          players: $players
        ) {
            success
            message
          }
      }
    `,
  },
};
